/*
 * @Author: zhaoyu zhaoyu@belink.com
 * @Date: 2022-08-04 22:18:44
 * @LastEditors: zhaoyu zhaoyu@belink.com
 * @LastEditTime: 2022-08-04 22:18:50
 * @FilePath: /pscd-portal-middle-office1/pscd-portal-middle-office/packages/clients/libraries/utils/lid.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2018-08-23 11:23:50
 * @modify date 2018-08-23 11:23:50
 * @desc [算法]
 */
import CryptoJS from 'crypto-js';
import jsrsasign from 'jsrsasign';
export class LidEncryption {
  static JWT(payload, secretSalt) {
    // Header
    var oHeader = { alg: 'HS256', typ: 'JWT' };
    // Payload
    var oPayload = payload;
    var sHeader = JSON.stringify(oHeader);
    var sPayload = JSON.stringify(oPayload);
    var sJWT = jsrsasign.KJUR.jws.JWS.sign(
      'HS256',
      sHeader,
      sPayload,
      secretSalt,
    );
    return sJWT;
  }

  static base64UrlEncode(str) {
    var encodedSource = CryptoJS.enc.Base64.stringify(str);
    var reg = new RegExp('/', 'g');
    encodedSource = encodedSource
      .replace(/=+$/, '')
      .replace(/\+/g, '-')
      .replace(reg, '_');
    return encodedSource;
  }

  static base64UrlDecode(str) {
    try {
      var decodedSource = CryptoJS.enc.Base64.parse(str).toString(
        CryptoJS.enc.Utf8,
      );
      return decodedSource;
    } catch (error) {}
  }
}
